import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, allowedOrganizationIds = [] }) => {
  const organizationId = useSelector((store) => store.user.organizationId);

  // If organization_id is not 1 or 2, redirect to df-dashboard
  if (allowedOrganizationIds.length > 0 && !allowedOrganizationIds.includes(organizationId)) {
    return <Navigate to="/dashboard/df-dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute; 